import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cash_document_hdr_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    stmt_no: fromDatatype.VarcharDatatypeInterface;
    transfer_type: fromDatatype.VarcharDatatypeInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    ref_no: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_cash_document_hdr_RowClass implements bl_fi_cash_document_hdr_RowInterface{
    guid : fromDatatype.GuidDataFieldInterface;
    stmt_no: fromDatatype.VarcharDatatypeInterface;
    transfer_type: fromDatatype.VarcharDatatypeInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    ref_no: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.GuidDataFieldInterface;
}